import { createSlice } from '@reduxjs/toolkit';
import { PageSortFilter } from '../../models/pageFilter.model';

const initialPageNumber = 0,
	initialPageSize = 10;
const initialState: PageSortFilter = {
	page: { page_number: initialPageNumber, page_size: initialPageSize },
	sort: { sort_column: 'RecruitName', sort_ascending: true },
};

const listPageAndSortReducerSlice = createSlice({
	name: 'listPageAndSortReducer',
	initialState,
	reducers: {
		setlistPageAndSort(state: PageSortFilter, action) {
			state = action.payload;
			return { ...state, ...action.payload };
		},
		resetListPageAndSort(state: PageSortFilter, action) {
			return initialState;
		},
	},
});

export const { setlistPageAndSort, resetListPageAndSort } =
	listPageAndSortReducerSlice.actions;
export default listPageAndSortReducerSlice.reducer;
